import { createFileRoute } from '@tanstack/react-router'

import { TelaDeConta } from '@/components/gestor/conta/TelaDeConta'

export const Route = createFileRoute('/gestor/conta')({ component: TelaDeConta })
